<template>
  <div class="app">
    <div class="h-screen">
      <nav
        class="navbar bg-white flex items-center justify-between px-10 py-3 z-20 fixed w-full z-20"
        aria-label="Global"
      >
        <div class="flex lg:flex-1">
          <a href="/" class="-m-1.5 p-1.5">
            <img class="h-8 w-auto" src="../assets/logo.png" alt="" />
          </a>
        </div>
        <div class="flex lg:hidden">
          <button
            type="button"
            class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-black"
            @click="mobileMenuOpen = true"
          >
            <span class="sr-only">Open main menu</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
              style="color: ##f3a323"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          </button>
        </div>
        <div class="hidden lg:flex lg:gap-x-12">
          <!-- <div class="relative group">
           
            <button
              class="flex items-center text-md font-semibold leading-6 text-amber-500 font-primary"
            >
              Product
              <svg
                class="ml-1 w-4 h-4"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>

 
            <div
              class="absolute left-0 mt-2 min-w-full bg-white shadow-lg rounded-lg z-50 w-56 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300"
            >
              <a
                v-for="item in navigation"
                :key="item.name"
                @click="pushRoute(item.id)"
                class="block px-4 py-2 text-md font-semibold leading-6 text-amber-500 font-primary cursor-pointer hover:bg-gray-100 focus:bg-gray-200 transition-colors duration-200 rounded"
              >
                {{ item.name }}
              </a>
            </div>
          </div> -->
          <a
            v-for="item in navigation"
            :key="item.name"
            href="#"
            class="text-md font-semibold leading-6 text-amber-500 font-primary"
            @click="pushRoute(item.id)"
            >{{ item.name }}</a
          >
         
          <a
            href=""
            target="#"
            class="text-md font-semibold leading-6 text-amber-500 font-primary"
            >Affiliate</a
          >
        </div>
        <div class="hidden lg:flex lg:flex-1 lg:justify-end">
          <div v-if="currentUser">
            <vdropdown placement="right">
              <!-- Button content -->
              <template v-slot:button>
                <div v-if="currentUser.user.avatar != null">
                  <img
                    class="ml-2 w-10 h-10 rounded-full border-2 border-gray-600 mr-3"
                    :src="url + currentUser.user.avatar"
                    alt="Saleh Mir"
                  />
                </div>
                <div v-else>
                  <img
                    class="ml-2 w-10 h-10 rounded-full border-2 border-gray-600 mr-3"
                    src="https://raw.githubusercontent.com/vuetailwind/storage/master/avatars/saleh-avatar.jpg"
                    alt="Saleh Mir"
                  />
                </div>

                <span class="mr-2 text-amber-500 font-primary">{{
                  currentUser.user.name
                }}</span>

                <svg
                  class="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M4.516 7.548c.436-.446 1.043-.481 1.576 0L10 11.295l3.908-3.747c.533-.481 1.141-.446 1.574 0 .436.445.408 1.197 0 1.615-.406.418-4.695 4.502-4.695 4.502a1.095 1.095 0 0 1-1.576 0S4.924 9.581 4.516 9.163c-.409-.418-.436-1.17 0-1.615z"
                  />
                </svg>
              </template>

              <!-- Opened dropdown content -->
              <template v-slot:content>
                <router-link :to="{ path: '/profile' }">
                  <a
                    class="flex w-full justify-between items-center rounded px-2 py-1 my-1 hover:bg-indigo-600 text-amber-500 font-primary"
                    href="#"
                    >Settings</a
                  >
                </router-link>

                <hr />

                <a
                  class="flex w-full justify-between items-center rounded px-2 py-1 my-1 hover:bg-red-600 text-amber-500 font-primary"
                  href="#"
                  @click="logOut()"
                  >Logout</a
                >
              </template>
            </vdropdown>
          </div>
          <div v-else class="p-4">
            <router-link :to="{ path: '/login' }">
              <a
                href="#"
                class="text-sm font-semibold leading-6 text-amber-500 font-primary"
                >Log in
                <span aria-hidden="true" style="color: white">&rarr;</span></a
              >
            </router-link>
          </div>
        </div>
      </nav>
      <Dialog
        as="div"
        class="lg:hidden"
        @close="mobileMenuOpen = false"
        :open="mobileMenuOpen"
      >
        <div class="fixed inset-0 z-50" />
        <DialogPanel
          class="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
        >
          <div class="flex items-center justify-between">
            <a href="#" class="-m-1.5 p-1.5">
              <span class="sr-only">Your Company</span>
              <img class="h-8 w-auto" src="../assets/logo.png" alt="" />
            </a>
            <button
              type="button"
              class="-m-2.5 rounded-md p-2.5 text-gray-700"
              @click="mobileMenuOpen = false"
            >
              <span class="sr-only">Close menu</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div class="mt-6 flow-root">
            <div class="-my-6 divide-y divide-gray-500/10">
              <div class="space-y-2 py-6">
                <a
                  v-for="item in navigation"
                  :key="item.name"
                  :href="item.href"
                  class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-amber-500 hover:bg-gray-50 font-primary"
                  >{{ item.name }}</a
                >
                <a
                  href="/trainer"
                  class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-amber-500 hover:bg-gray-50 font-primary"
                  >Trainer</a
                >
              </div>
              <div class="py-6">
                <span v-if="currentUser" class="my-4">
                  <a
                    href="/profile"
                    class="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50 font-primary text-amber-500"
                    >Settings</a
                  >
                </span>
                <span v-if="currentUser" class="my-4">
                  <a
                    class="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50 font-primary text-amber-500"
                    @click="logOut()"
                    >Logout</a
                  >
                </span>
                <span v-else>
                  <a
                    href="/login"
                    class="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50 font-primary text-amber-500"
                    >Log in</a
                  >
                </span>
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
      <router-view />
      <input class="chatMenu hidden" id="offchatMenu" type="checkbox" />
      <label class="chatButton" for="offchatMenu">
        <svg class="svg-1" viewBox="0 0 32 32">
          <g>
            <path
              d="M16,2A13,13,0,0,0,8,25.23V29a1,1,0,0,0,.51.87A1,1,0,0,0,9,30a1,1,0,0,0,.51-.14l3.65-2.19A12.64,12.64,0,0,0,16,28,13,13,0,0,0,16,2Zm0,24a11.13,11.13,0,0,1-2.76-.36,1,1,0,0,0-.76.11L10,27.23v-2.5a1,1,0,0,0-.42-.81A11,11,0,1,1,16,26Z"
            ></path>
            <path
              d="M19.86,15.18a1.9,1.9,0,0,0-2.64,0l-.09.09-1.4-1.4.09-.09a1.86,1.86,0,0,0,0-2.64L14.23,9.55a1.9,1.9,0,0,0-2.64,0l-.8.79a3.56,3.56,0,0,0-.5,3.76,10.64,10.64,0,0,0,2.62,4A8.7,8.7,0,0,0,18.56,21a2.92,2.92,0,0,0,2.1-.79l.79-.8a1.86,1.86,0,0,0,0-2.64Zm-.62,3.61c-.57.58-2.78,0-4.92-2.11a8.88,8.88,0,0,1-2.13-3.21c-.26-.79-.25-1.44,0-1.71l.7-.7,1.4,1.4-.7.7a1,1,0,0,0,0,1.41l2.82,2.82a1,1,0,0,0,1.41,0l.7-.7,1.4,1.4Z"
            ></path>
          </g>
        </svg>
        <svg class="svg-2" viewBox="0 0 512 512">
          <path
            d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
          ></path>
        </svg>
      </label>
      <div class="chatBox">
        <div class="chatContent">
          <div class="chatHeader">
            <svg viewbox="0 0 32 32">
              <path
                d="M24,22a1,1,0,0,1-.64-.23L18.84,18H17A8,8,0,0,1,17,2h6a8,8,0,0,1,2,15.74V21a1,1,0,0,1-.58.91A1,1,0,0,1,24,22ZM17,4a6,6,0,0,0,0,12h2.2a1,1,0,0,1,.64.23L23,18.86V16.92a1,1,0,0,1,.86-1A6,6,0,0,0,23,4Z"
              ></path>
              <rect height="2" width="2" x="19" y="9"></rect>
              <rect height="2" width="2" x="14" y="9"></rect>
              <rect height="2" width="2" x="24" y="9"></rect>
              <path
                d="M8,30a1,1,0,0,1-.42-.09A1,1,0,0,1,7,29V25.74a8,8,0,0,1-1.28-15,1,1,0,1,1,.82,1.82,6,6,0,0,0,1.6,11.4,1,1,0,0,1,.86,1v1.94l3.16-2.63A1,1,0,0,1,12.8,24H15a5.94,5.94,0,0,0,4.29-1.82,1,1,0,0,1,1.44,1.4A8,8,0,0,1,15,26H13.16L8.64,29.77A1,1,0,0,1,8,30Z"
              ></path>
            </svg>
            <div class="chatTitle">
              Silahkan chat dengan tim kami
              <span>Admin akan membalas dalam beberapa menit</span>
            </div>
          </div>
          <div class="chatText">
            <span>Halo, Ada yang bisa kami bantu?</span>
            <span class="typing">...</span>
          </div>
        </div>

        <a
          class="chatStart"
          :href="
            'https://api.whatsapp.com/send?phone=' +
            tenant.phone +
            '&text=Hallo Admin XSPORTAINMENT,%20Saya%20ingin%20bertanya'
          "
          rel="nofollow noreferrer"
          target="_blank"
        >
          <span>Mulai chat...</span>
        </a>
      </div>
      <footer class="bg-neutral-900 w-full">
        <div class="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
          <div class="mb-6 md:mb-0 p-4 py-6 lg:py-8">
            <a href="#" class="flex items-center">
              <img
                src="../assets/logo-white.png"
                class="mr-3"
                alt="Xsport Logo"
                style="width: 280px"
              />
            </a>
          </div>
          <div class="md:flex md:justify-between">
            <div class="grid gap-4 grid-cols-2 lg:grid-cols-5">
              <div>
                <h2
                  class="mb-6 text-sm font-semibold text-gray-900 uppercase text-white font-primary"
                >
                  Location
                </h2>
                <ul
                  class="text-gray-600 dark:text-gray-400 font-medium"
                  v-for="item in locations"
                  :key="item.id"
                >
                  <li class="mb-2">
                    <a
                      class="hover:underline font-primary"
                      target="_blank"
                      href="https://www.google.com/maps/place/Xsportainment/@-6.1823439,106.8303214,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f5618f58212d:0x64dba6564e2b28a7!8m2!3d-6.1823439!4d106.8303214!16s%2Fg%2F11ks4909_3?entry=ttu&g_ep=EgoyMDI1MDYwOS4wIKXMDSoASAFQAw%3D%3D"
                      >{{ item.name }}</a
                    >
                  </li>
                </ul>
              </div>
              <div>
                <h2
                  class="mb-6 text-sm font-semibold text-gray-900 uppercase text-white font-primary"
                >
                  Service
                </h2>

                <ul class="text-gray-600 dark:text-gray-400 font-medium">
                  <li class="mb-2">
                    <a class="hover:underline font-primary" href="/trainer"
                      >Trainer</a
                    >
                  </li>
                  <template v-for="item in categories" :key="item.id">
                    <li class="mb-2">
                      <p
                        class="hover:underline font-primary"
                        @click="pushRoute(item.id)"
                      >
                        {{ item.name }}
                      </p>
                    </li>
                  </template>
                  <li class="mb-2">
                    <a class="hover:underline font-primary" href="/about-us"
                      >About-us</a
                    >
                  </li>
                </ul>
              </div>
              <div>
                <h2
                  class="mb-6 text-sm font-semibold text-gray-900 uppercase text-white font-primary"
                >
                  Social Media
                </h2>
                <ul class="text-gray-600 dark:text-gray-400 font-medium">
                  <li class="mb-2">
                    <a
                      href="https://www.instagram.com/telprodico"
                      target="_blank"
                      class="hover:underline font-primary"
                      >Instagram</a
                    >
                  </li>
                  <!-- <li class="mb-2">
                              <a :href="'#'" target="_blank" class="hover:underline font-primary">Tiktok</a>
                          </li> -->
                </ul>
              </div>
              <div>
                <h2
                  class="mb-6 text-sm font-semibold text-gray-900 uppercase text-white font-primary"
                >
                  Contact
                </h2>
                <ul
                  class="text-gray-600 dark:text-gray-400 font-medium font-primary"
                >
                  <li class="mb-4">
                    <p class="hover:underline text-ellipsis">
                      Address:<br />
                      {{ tenant.head_office_address }}
                    </p>
                  </li>
                  <li>
                    <p class="hover:underline text-ellipsis break-all">
                      Email: <br />
                      {{ tenant.email }}
                    </p>
                  </li>
                  <br />
                  <li>
                    <p>Call Center : 1500473</p>
                  </li>
                  <br />
                  <li>
                    <p>Contact Admin Xsport : 0822 1155 9400</p>
                  </li>
                </ul>
              </div>
              <div>
                <a
                  href="/privacy-policy"
                  class="mb-6 text-sm font-semibold text-gray-900 uppercase text-white"
                  >Privacy & Policy</a
                >
              </div>
            </div>
          </div>
          <hr class="my-6 border-gray-200 sm:mx-auto border-gray-700 lg:my-8" />
          <div class="sm:flex sm:items-center sm:justify-between">
            <span
              class="text-sm text-gray-500 sm:text-center text-gray-400 font-primary"
              >© {{ new Date().getFullYear() }}
              <a href="#" class="hover:underline">Xsportaiment™</a>. All Rights
              Reserved.
            </span>
            <div class="flex mt-4 space-x-6 sm:justify-center sm:mt-0">
              <a
                :href="'https://www.facebook.com/mytelkompropertyofficial'"
                target="_blank"
                class="text-gray-500 hover:text-gray-900 text-white"
              >
                <svg
                  class="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="sr-only font-primary">Facebook page</span>
              </a>
              <a
                :href="'https://www.instagram.com/telprodico'"
                target="_blank"
                class="text-gray-500 hover:text-gray-900 text-white"
              >
                <svg
                  class="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span class="sr-only font-primary">Instagram page</span>
              </a>
              <a
                :href="'https://twitter.com/_telkomproperty'"
                target="_blank"
                class="text-gray-500 hover:text-gray-900 text-white"
              >
                <svg
                  class="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
                  />
                </svg>
                <span class="sr-only font-primary">Twitter page</span>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import { Dialog, DialogPanel } from "@headlessui/vue";
import { Bars3Icon, XMarkIcon } from "@heroicons/vue/24/outline";

import vdropdown from "../components/DropdownHeader.vue";
import { webUrl } from "../utils/config";
import AuthService from "@/services/auth.service";
import ApiService from "@/services/api.service";
import productService from "@/services/product.service";

export default {
  name: "main-layout",
  components: { vdropdown },
  data() {
    return {
      tenant: "",
      mobileMenuOpen: false,
      url: webUrl,
      isLocation: false,
      navigation: [],
      locations: [],
      categories: [],
      secret: "123#$%",
      isDropDownLocation: false,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
    AuthService.getDataTenant().then(
      (response) => {
        var data = response.data;
        this.tenant = data;
        this.getLocation(data.id);
        this.getCategories(data.id);
      },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  },
  methods: {
    getLocation(tenantId) {
      ApiService.getDataLocation(tenantId).then(
        (response) => {
          var data = response.data;
          this.locations = data;
          // if(data != null){
          //   localStorage.setItem('locations', JSON.stringify(data));
          // }else{
          //   localStorage.setItem('locations', null);
          // }
          // this.content = response.data;
        },
        (error) => {
          this.content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    getCategories(tenantId) {
      productService.getDataProductCategories(tenantId).then(
        (response) => {
          var data = response.data.data;
          this.categories = data;
          data.forEach((category) => {
            this.navigation.push({
              id: category["id"],
              name: category["name"],
              href: "/category?categoryId=" + category["id"],
            });
          });
        },
        (error) => {
          this.content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    hadleNav() {
      this.isToggle = !this.isToggle;
    },
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
    pushRoute(categoryId) {
      this.$router
        .push({
          name: "category",
          query: {
            categoryId: categoryId,
          },
        })
        .then((response) => {
          location.reload();
        });
    },
  },
};
</script>
